import {Component, OnDestroy, OnInit} from '@angular/core';
import {Actions, ofActionSuccessful, Select, Store} from "@ngxs/store";
import {ResourceGroupsState} from "../state/resource-groups.state";
import {Observable, Subject} from "rxjs";
import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {ResourceGroupsActions} from "../state/resource-groups.actions";
import {takeUntil} from "rxjs/operators";
import {MatDialogRef} from "@angular/material/dialog";
import {ResourceGroup} from "../../model/resource-group";

@Component({
  selector: 'resource-group-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit, OnDestroy{
  @Select(ResourceGroupsState.currentItem) public item: Observable<ResourceGroup>;
  @Select(ResourceGroupsState.canSave) public canSave$: Observable<boolean>;

  editForm = new UntypedFormGroup({
    name: new UntypedFormControl('', Validators.required),
  });

  private ngUnsubscribe = new Subject();

  constructor(private store: Store, private actions$: Actions, private dialogRef:MatDialogRef<EditComponent>) {}


  ngOnInit() {
    this.actions$
      .pipe(
        ofActionSuccessful(ResourceGroupsActions.Save),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(() => {this.dialogRef.close()});
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onSubmit() {
    this.store.dispatch(new ResourceGroupsActions.Save());
  }
}
